import { Stack } from '@optimus-web/core';
import { DefaultErrorBoundary } from '@mews-commander/ui';
import { WithScope } from '@mews-commander/types';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { useInvalidateReservationGroupAllQuery } from '@mews-commander/core/entities';
import { fetchCurrentEnterpriseCheckedReservations } from '../../actions';
import { WithReservationsSameService } from '../withReservationsSameService';
import ResendEmailFormCard from './ResendEmailFormCard';

export const MailingTab = ({ scope }: WithScope) => {
    const reservationModuleReactQueryEnabled = useFeatureFlag(FeatureFlag.reservationModuleReactQueryEnabled);
    const dispatch = useCommanderThunkDispatch();
    const refetchGroup = () => dispatch(fetchCurrentEnterpriseCheckedReservations({ scope }));
    const invalidateReservations = useInvalidateReservationGroupAllQuery(scope);

    return (
        <DefaultErrorBoundary>
            <WithReservationsSameService scope={scope}>
                <Stack spacing="200" vertical>
                    <ResendEmailFormCard
                        form={`resend-email-form-${scope}`}
                        /* @ts-expect-error $TSFixMeError: Type '{ form: string; scope: any; refetchGroup: any; }' is not assignable to type 'IntrinsicAttributes & Omit<Omit<Dispa... */
                        scope={scope}
                        refetchGroup={reservationModuleReactQueryEnabled ? invalidateReservations : refetchGroup}
                    />
                </Stack>
            </WithReservationsSameService>
        </DefaultErrorBoundary>
    );
};
